import { useState } from 'react';
import PropTypes from 'prop-types';
import { ImgListComponent } from '../../../views/ServicesHistoryDetails/components/summaryComponents/ImgListComponent';

export const ImagesComponent = ({ field, value = [], onChange, nodeHierarchy = [], disabledField }) => {
  const [images, setImages] = useState(value);

  const onChangeValue = (imgList) => {
    setImages(imgList);
    onChange(imgList);
  };

  return (
    <ImgListComponent
      field={field}
      value={images}
      onChange={onChangeValue}
      parents={nodeHierarchy}
      disabledField={disabledField}
    />
  );
};

ImagesComponent.propTypes = {
  field: PropTypes.object,
  value: PropTypes.array,
  onChange: PropTypes.func,
  nodeHierarchy: PropTypes.array,
  disabledField: PropTypes.bool,
};
